import { BubbleTail } from './BubbleTail'

export default BubbleTail
